import { path } from 'ramda';

import { TILE_TYPE } from '@shared/constants';

import { EXCLUSIVE_OFFERS_PAGE_CAMPAIGN_SLUG } from '@/constants';
import BFF from '@/services/BFF';
import filterAvailableProperties from '@/utils/filterAvailableProperties';
import redirect from '@/utils/redirect';

const getInitialProps = async (ctx) => {
  try {
    const { campaignSlug } = ctx.query;

    if (!campaignSlug || campaignSlug === EXCLUSIVE_OFFERS_PAGE_CAMPAIGN_SLUG) {
      redirect({ ctx, destination: '/deals' });
    }

    const [destinations, campaign] = await Promise.all([
      BFF.getDestinations(ctx)(),
      BFF.getCampaign(ctx)(campaignSlug),
    ]);

    const { tiles, campaignLandingPage } = campaign;

    const campaignProperties = tiles
      .filter((tile) => tile.propertyContent)
      .map((tile) => tile.propertyContent);

    const propertyIds = campaignProperties.map(({ id }) => id);
    const propertiesContent = await BFF.getPropertiesContent(ctx)(propertyIds);

    const availablePropertiesIds = filterAvailableProperties(
      campaignProperties,
      propertiesContent,
    ).map(({ id }) => id);

    const availableTiles = tiles
      .filter((tile) => {
        if (!tile.propertyContent) {
          // If there is no property content, it is a cross sell banner placeholder;
          return true;
        }

        return availablePropertiesIds.includes(tile.propertyContent.id);
      })
      .map((tile) => {
        switch (tile.type) {
          case TILE_TYPE.FEATURED_PROPERTY:
            return {
              ...propertiesContent.find(
                (propertyContent) =>
                  propertyContent.id === tile.propertyContent.id,
              ),
              campaign: tile,
              destination: tile.propertyContent.destination,
              type: tile.type,
            };
          case TILE_TYPE.PROCURED_OFFER:
            return {
              ...tile,
              ...propertiesContent.find(
                (propertyContent) =>
                  propertyContent.id === tile.propertyContent.id,
              ),
            };
          default:
            return tile;
        }
      });

    return {
      ...(await BFF.getAppSettings(ctx)()),
      campaign,
      destinations: destinations.filter(({ name }) =>
        campaignLandingPage.destinations.includes(name),
      ),
      tiles: availableTiles,
    };
  } catch (error) {
    if (path(['response', 'status'])(error) === 404) {
      redirect({ ctx, destination: '/deals' });

      return {};
    }

    throw error;
  }
};

export default getInitialProps;
